import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-messenger }}\n{{yield}}",{ moduleName: "embercom/components/messenger-preview/translation-loader-wrapper.hbs" })